<!--
 * @message: 
 * @Author: Betway<848032671@qq.com>
 * @Github: github
 * @Date: 2020-07-24 13:51:54
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Claim\ClaimTransactionPropertyGroup\components\MappingPopup5.vue
 * @最后编辑: Betway
 * @最后修改时间: 2022-02-17 14:39:27
-->
<template>
  <normalDialog
    :title="$t('label_essweb_form_property_dialog_title')"
    :dialog="show"
    @close="closeDialog"
    maxWidth="680"
  >
    <template v-slot:content>
      <v-form ref="form" lazy-validation v-if="PropertyData">
        <v-row align="center">
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_form_property_dialog_propertyNameLabel")
            }}</v-sheet>
            <v-text-field
              single-line
              filled
              dense
              hide-details
              :value="$getCommonLangValue(PropertyData.property_master_name)"
              :disabled="true"
            ></v-text-field>
          </v-col>
          <v-container class="d-flex pa-0">
            <v-spacer></v-spacer>
            <v-btn
              text
              small
              class="text-capitalize"
              color="primary"
              @click="addValue()"
            >
              {{ $t("label_essweb_form_property_dialog_addValueBtnLabel") }}
              <span class="material-icons-round">add</span>
            </v-btn>
          </v-container>
          <template v-for="(item, index) in MappingData">
            <v-row :key="`row${index}`" class="pa-0 ma-0">
              <v-col md="5" class="pt-0 pb-0">
                <DateTimePicker
                  type="date"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :defaultTime="item.effective_utc_datetime"
                  :label="
                    $t(
                      'label_essweb_form_property_dialog_effectiveStartDateLabel'
                    )
                  "
                  placeholder="YYYY/MM/DD"
                  :refuseDate="refuseDate"
                  @change="(time) => (item.effective_utc_datetime = time)"
                ></DateTimePicker>
              </v-col>
              <v-col md="5" class="pt-0 pb-0">
                <template v-if="prompt">
                  <v-sheet class="mrc_text_require text--secondary">{{
                    $t("label_essweb_form_property_dialog_valueLabel")
                  }}</v-sheet>
                  <v-autocomplete
                    :items="promptData"
                    item-text="view_fields"
                    item-value="value_field"
                    dense
                    :rules="$GetRules(['_Require_Rules'], [null])"
                    v-model="item.value"
                    single-line
                    :menu-props="{
                      offsetY: true,
                      transition: 'slide-y-transition',
                      rounded: true,
                      contentClass: 'elevation-4',
                    }"
                    :placeholder="
                      $t('label_essweb_form_property_dialog_valueLabel')
                    "
                    filled
                  >
                    <template v-slot:no-data> <noContent /> </template
                  ></v-autocomplete>
                </template>
                <template v-if="data_type">
                  <v-sheet class="mrc_text_require text--secondary">{{
                    $t("label_essweb_form_property_dialog_valueLabel")
                  }}</v-sheet>
                  <template v-if="data_type === 'boolean'">
                    <v-select
                      :items="[
                        {
                          text: $t('label_essweb_system_label_trueLabel'),
                          value: '1',
                        },
                        {
                          text: $t('label_essweb_system_label_falseLabel'),
                          value: '0',
                        },
                      ]"
                      item-text="text"
                      item-value="value"
                      filled
                      :menu-props="{
                        offsetY: true,
                        transition: 'slide-y-transition',
                        rounded: true,
                        contentClass: 'elevation-4',
                      }"
                      single-line
                      v-model="item.value"
                      :label="
                        $t('label_essweb_system_label_trueLabel') +
                        '/' +
                        $t('label_essweb_system_label_falseLabel')
                      "
                      dense
                    >
                      <template v-slot:no-data> <noContent /> </template
                    ></v-select>
                  </template>
                  <template
                    v-if="data_type === 'int' || data_type === 'bigint'"
                  >
                    <v-text-field
                      single-line
                      type="number"
                      maxlength="50"
                      :rules="
                        $GetRules(
                          [
                            '_Require_Rules',
                            data_type === 'bigint'
                              ? '_Number_negative_reduce'
                              : '_Number_negative',
                          ],
                          [null, null]
                        )
                      "
                      v-model="item.value"
                      :placeholder="
                        $t('label_essweb_form_property_dialog_valueLabel')
                      "
                      filled
                      dense
                    ></v-text-field>
                  </template>
                  <template v-if="data_type === 'String'">
                    <v-text-field
                      single-line
                      maxlength="50"
                      type="string"
                      :rules="$GetRules(['_Require_Rules'], [null])"
                      v-model="item.value"
                      :placeholder="
                        $t('label_essweb_form_property_dialog_valueLabel')
                      "
                      filled
                      dense
                    ></v-text-field>
                  </template>
                </template>
              </v-col>
              <v-col md="1" class="d-flex align-center pt-0 pb-0">
                <v-btn icon @click="onDelete(item.actionid)">
                  <span class="material-icons-round">delete</span>
                </v-btn>
              </v-col>
            </v-row>
          </template>
        </v-row>
      </v-form>
    </template>
    <template v-slot:actions>
      <CardActions closeBtn @close="closeDialog" :cancelBtn="false" />
      <!--  用于解决bug201 本地操作start -->
      <!-- <CardActions saveBtn @save="toSave" @cancel="closeDialog" /> -->
    </template>
  </normalDialog>
</template>
<script>
import { mapGetters } from "vuex";

import dayjs from "dayjs";
export default {
  name: "MappingPopup5",
  props: {
    show: { default: false, type: Boolean },
    PropertyData: { default: "", type: [Object, String] },
  },
  computed: {
    ...mapGetters(["defaultUTC"]),
    refuseDate() {
      let arr = [];
      this.MappingData.forEach((item) => {
        if (item.effective_utc_datetime) {
          arr.push(item.effective_utc_datetime);
        }
      });
      return arr;
    },
    promptData() {
      return this.$getSelectTrans(this.promptDataList, "view_fields");
    },
    fieldStatus() {
      // 弹窗是否是可关闭状态
      let canClose = true;
      if (!this.MappingData || this.MappingData.length <= 0) return true;
      this.MappingData.map((item) => {
        if (item.value === "" || item.effective_utc_datetime === "") {
          canClose = false;
        }
        if (item.value === "" && item.effective_utc_datetime === "") {
          canClose = true;
        }
      });
      return canClose;
    },
  },
  watch: {
    show(val) {
      const that = this;
      if (!val) {
        this.MappingData = [];
      } else {
        this.curData = this.PropertyData;
        this.MappingData = this.PropertyData.changeList;
        // 用于解决bug201 本地操作start
        // this.MappingData = this.MappingData.filter((ele) =>
        //   ele["isSave"] ? ele["isSave"] === true : true
        // );
        // 用于解决bug201 本地操作end
        if (this.PropertyData.changeList.length <= 0) {
          this.insterUuid = 0;
          //有默认值
          if (this.curData["value"] != "" && this.curData["value"] != null) {
            this.addValue(
              dayjs(new Date()).add(-1, "day").format("YYYY-MM-DD"),
              this.curData["value"]
            );
          }
        } else {
          this.insterUuid = 0;
          this.PropertyData.changeList.forEach((it) => {
            if (Number(it.actionid) > that.insterUuid) {
              that.insterUuid = it.actionid;
            }
          });
        }
      }
    },
    PropertyData: {
      handler(val) {
        if (val) {
          this.refreshValue(val); //超过3级special
          if (val.prompt_name) {
            this.prompt = val.prompt_name;
          } else {
            if (val.data_type) {
              this.data_type = val.data_type;
            }
          }
        } else {
          this.prompt = null;
          this.data_type = null;
        }
      },
      deep: true,
    },
    prompt(val) {
      //高级参照获取
      const that = this;
      if (val)
        this.$findPrompt({
          prompt_name: val,
        }).then((res) => {
          that.promptDataList = res.data;
        });
    },
  },
  mounted() {
    this.getOnlineSystemDate();
  },
  data() {
    return {
      MappingData: [],
      promptDataList: [],
      prompt: null,
      curDate: null,
      curData: [],
      data_type: null,
      insterUuid: 0,
    };
  },
  methods: {
    refreshValue(obj) {
      if (
        obj &&
        obj.property_master_code.indexOf("|") != -1 &&
        obj.changeList
      ) {
        let arr = obj.changeList.filter(
          (ele) => ele.effective_utc_datetime !== ""
        );
        this.$emit("confirm", this.curData, arr);
      }
    },
    closeDialog: function () {
      if (
        !this.fieldStatus &&
        this.$refs["form"] &&
        !this.$refs["form"].validate()
      ) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curData["changeList"] = this.MappingData.filter(
        (ele) => ele.value !== "" && ele.effective_utc_datetime !== ""
      );

      this.$emit("close");
    },
    getOnlineSystemDate: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "hehe",
        url: "/other/get-system-timestamp/",
        data: {},
      }).then((res) => {
        that.curDate = that.$getDateTime(res.data, "YYYY-MM-DD");
      });
    },
    toSave: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      // this.MappingData.map(item => {
      //   if (dayjs(item.effective_utc_datetime).isBefore(dayjs(this.curDate))) {
      //     item.is_eff = true;
      //   } else {
      //     item.is_eff = false;
      //   }
      // });
      // const that = this;
      // var value = "";
      // let arr = this.MappingData;
      // let dateArr = [];
      // arr.forEach(item => {
      //   if (item.effective_utc_datetime == "") return "";
      //   if (dayjs(item.effective_utc_datetime).isBefore(dayjs(this.curDate))) {
      //     dateArr.push(that.$getTimeValue(item.effective_utc_datetime));
      //   }
      // });
      // if (dateArr.length) {
      //   let date = that.$getDateTime(Math.max(true, dateArr), "YYYY-MM-DD");
      //   if (arr.find(item => item.effective_utc_datetime == date))
      //     value = arr.find(item => item.effective_utc_datetime == date)[
      //       "value"
      //     ];
      // }
      // this.curData.value = value;
      // 用于解决bug201 本地操作start
      // this.MappingData.map((item) => {
      //   item["isSave"] ? (item["isSave"] = true) : null;
      // });
      // 用于解决bug201 本地操作end
      this.curData["changeList"] = this.MappingData;
      this.$emit("confirm", this.curData);
    },
    onDelete: function (actionid) {
      this.MappingData = this.MappingData.filter(
        (ele) => ele.actionid !== actionid
      );
      this.curData["changeList"] = this.MappingData;
      // this.$emit("confirm", this.curData);
    },
    addValue: function (date, value) {
      this.insterUuid = this.insterUuid + 1;
      this.MappingData.push({
        actionid: this.insterUuid,
        claim_transaction_type_property_master_uuid:
          this.PropertyData.claim_transaction_type_property_master_uuid,
        claim_transaction_type_property_master_code:
          this.PropertyData.property_master_code,
        value: value ? value : "",
        // isSave: false, //是否保存
        effective_utc_datetime: date ? date : "",
        effective_time_zone: this.defaultUTC,
        remarks: "",
      });
    },
  },
};
</script>
